import { Col, Row, Skeleton } from "antd";
import {
  CalendarComp,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import styles from "./EventsCalendar.module.css";
import { useEffect, useRef, useState } from "react";
import Modal from "../../../components/modal/Modal";
import people1 from "../../../assets/people1.png";
import people2 from "../../../assets/people2.png";
import people3 from "../../../assets/people3.png";
import people4 from "../../../assets/people4.png";
import dummy from "../../../assets/dummy.jpg";
import { CheckListMiddleware } from "../../../Store/Middlewares/CheckListMiddleware";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ShareChecklistModal from "./ShareChecklistModal/ShareCheckListModal";

const tasks = [
  { title: "Finalize Caterer" },
  { title: "Book Florist" },
  { title: "Lock Photographer" },
  { title: "Book Florist" },
];

const people = [
  { name: "Kurt Bates", job: "Musician", image: people1 },
  { name: "Isabella Bates", job: "Florist", image: people2 },
  { name: `Lucy Steve's`, job: "Makeup Artist", image: people3 },
  { name: "James Hales", job: "Caterer", image: people4 },
];

const EventsCalendar = () => {
  const user = useSelector((state) => state.AuthReducer.user.role);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setloading] = useState(false);
  const [checklistData, setChecklistData] = useState([]);
  const [checklisId, setChecklisId] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [markedDate, setMarkedDate] = useState([]);

  const { state } = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    let eventData = {
      id: state?.eventData?.id,
      date: selectedDate,
      user_role: user,
    };
    dispatch(CheckListMiddleware.getCalendarCheckList(eventData)).then(
      (data) => {
        console.log("data==========================", data);
        setChecklistData(data?.checklists);
        setMarkedDate(data?.dates ? data?.dates : []);
      }
    );
  }, []);

  const getCalendarData = (date) => {
    let dates = markedDate?.map(function (x) {
      return moment(x).format("YYYY-MM-DD");
    });
    let selectedDate = moment(date).format("YYYY-MM-DD");
    let exist = dates.includes(selectedDate) ? true : false;

    if (exist) {
      setloading(true);
      let eventData = {
        id: state?.eventData?.id,
        date: selectedDate,
        user_role: user,
      };
      dispatch(CheckListMiddleware.getCalendarCheckList(eventData))
        .then((data) => {
          console.log("data==========================", data);
          setChecklistData(data?.checklists);
          setMarkedDate(data?.dates ? data?.dates : []);
          setSelectedDate(selectedDate);
          setloading(false);
        })
        .catch(() => setloading(false));
    }
  };

  console.log("checklistData", checklistData);

  const onPressSend = (vendorID) => {
    // setModal(false);
    let checkListData = {
      checklist_id: checklisId,
      event_id: state?.eventData?.id,
      vendor_id: vendorID,
    };
    dispatch(CheckListMiddleware.sendCheckList(checkListData));
    // .then(() =>{})
    // .catch((err) => console.log(err));
  };
  return (
    <Row>
      <Col xs={24} lg={12}>
        <CalendarComp getLoanData={getCalendarData} markedDate={markedDate} />
      </Col>
      <Col xs={24} lg={12} className={styles.rightCol}>
        <Row className={styles.dateRow}>
          <TextComponent textClass={styles.dateText}>
            {selectedDate
              ? moment(selectedDate).format("dddd, MMM DD, YYYY")
              : "--"}
          </TextComponent>
        </Row>
        <Skeleton loading={loading}>
          <Row className={styles.taskRow}>
            {checklistData?.map((task) => (
              <Row className={styles.taskBox}>
                <Col>
                  {/* <TextComponent>Due: Today, Sunday 1</TextComponent> */}
                  <TextComponent textClass={styles.taskTitle}>
                    {task?.name}
                  </TextComponent>
                </Col>
                {/* <Col>
                  <div
                    className={styles.iconBtn}
                    onClick={() => {
                      setChecklisId(task?.id);
                      setModalOpen(true);
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 26 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.0392 15.6811C19.8387 15.6811 18.7588 16.1655 17.9921 16.9386L9.03356 12.7319C9.06437 12.5342 9.08559 12.3342 9.08559 12.1283C9.08559 11.9277 9.06538 11.732 9.03609 11.5397L17.9815 7.37896C18.7487 8.1584 19.8336 8.64767 21.0392 8.64767C23.3636 8.64767 25.2481 6.84028 25.2481 4.61095C25.2481 2.38113 23.3636 0.574219 21.0392 0.574219C18.7149 0.574219 16.8304 2.38113 16.8304 4.61095C16.8304 4.8115 16.8506 5.00672 16.8799 5.19952L7.93452 9.36026C7.1673 8.58082 6.0829 8.09155 4.87678 8.09155C2.55191 8.09155 0.667969 9.89895 0.667969 12.1283C0.667969 14.3581 2.55191 16.165 4.87678 16.165C6.07735 16.165 7.1572 15.6806 7.92391 14.9074L16.8825 19.1142C16.8517 19.3114 16.8304 19.5119 16.8304 19.7178C16.8304 21.9476 18.7149 23.7545 21.0392 23.7545C23.3636 23.7545 25.2481 21.9476 25.2481 19.7178C25.2481 17.488 23.3636 15.6811 21.0392 15.6811Z"
                        fill="var(--primary-color)"
                      />
                    </svg>
                  </div>
                </Col> */}
              </Row>
            ))}
          </Row>
        </Skeleton>
        <Modal
          isModalOpen={modalOpen}
          setIsModalOpen={setModalOpen}
          closable={true}
          pinkBg={true}
        >
          <ShareChecklistModal onPressSend={onPressSend} />
        </Modal>
      </Col>
    </Row>
  );
};

export default EventsCalendar;
